module.exports = __webpack_public_path__ + "static/media/机器翻译).8f9ffd37.png";